import { render, staticRenderFns } from "./DuctpieceIndex.vue?vue&type=template&id=58e4c339&scoped=true&"
import script from "./DuctpieceIndex.vue?vue&type=script&lang=js&"
export * from "./DuctpieceIndex.vue?vue&type=script&lang=js&"
import style0 from "./DuctpieceIndex.vue?vue&type=style&index=0&id=58e4c339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e4c339",
  null
  
)

export default component.exports